import { render } from "./StatsBlockComponent.vue?vue&type=template&id=f1ffa7d0"
import script from "./StatsBlockComponent.vue?vue&type=script&lang=js"
export * from "./StatsBlockComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__